<template>
  <el-scrollbar style="height:100%; overflow-x:hidden;">
    <div class="index-box">
      <Header></Header>
      <div>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24">
            <div class="banner-box">
              <!-- <div class="b-title" style="background:#F09BA0;">最新资讯</div> -->
              <div class="i-banner" id>
                <el-carousel
                  :height="screenType=='small'?imgHeight+'px':'880px'"
                  arrow="always"
                  :interval="6000"
                >
                  <el-carousel-item v-for="(item,index) in banner" :key="index">
                    <div
                      class="banner-tem"
                      @click="handleClick(item)"
                      :style="`background-image: url(${item.coverImg})`"
                    >
                      <div class="b-cover"></div>
                      <div class="b-text" :title="item.subtitle">
                        <b>{{item.title}}</b>
                        &nbsp;：&nbsp;{{item.subtitle}}
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-col>
        </el-row>
        <div style="height:60px;"></div>
        <div class="new-main">
          <div class="activity">
            <div class="act-tle">最新活动</div>
            <div style="height:496px;">
              <el-carousel :interval="400000" type="card" height="496px" arrow="always">
                <el-carousel-item v-for="(item,index) in eventArr" :key="index">
                  <a
                    :href="'/event?id='+item.id"
                    target="_blank"
                    class="event-tem"
                    :style="`background-image: url(${item.coverImg})`"
                  ></a>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div style="height:30px;"></div>
          <div class="i-glue" id="xyou" style>
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="16">
                <!-- <div class="b-title" style="background:#F09BA0;">
                  新游速递
                  <a class="b-tb-more" target="_blank" href="/list">更多游戏</a>
                </div>-->
                <div class="n-m-title">
                  <span>新游速递</span>
                  <a target="_blank" href="/list">更多游戏</a>
                </div>
                <el-row class="game-main" :gutter="16">
                  <el-col
                    :xs="24"
                    :sm="12"
                    class="templete"
                    v-for="tem in gameList.slice(0, 6)"
                    :key="tem.id"
                  >
                    <div class="n-m-g-tem">
                      <a
                        :href="'/more?id='+tem.id"
                        target="_blank"
                        :title="tem.name"
                        :style="`background-image: url(${tem.coverImg.indexOf('http')>-1?tem.coverImg:'/api'+tem.coverImg})`"
                      >
                        <span class="g-t-cover"></span>
                        <div class="g-t-info">
                          <p>{{tem.name}}</p>
                          <span>{{tem.cateId?cateObj[tem.cateId]: '暂无分类'}}</span>
                          <span>{{tem.subjectId?subObj[tem.subjectId]: '暂无题材'}}</span>
                        </div>
                      </a>
                    </div>
                    <!-- <div class="con">
                      <a :href="'/more?id='+tem.id" target="_blank">
                        <div class="c1">
                          <span>
                            <img
                              :src="tem.coverImg.indexOf('http')>-1?tem.coverImg:'/api'+tem.coverImg"
                            />
                          </span>
                        </div>
                        <div class="c2">
                          <div class="tit">
                            <a :title="tem.name">{{tem.name}}</a>
                          </div>

                          <div class="info">
                            <span class="ex" :title="tem.schedule">测试情况：{{tem.schedule}}</span>
                            <span>运营商：{{tem.provider || '暂无'}}</span>
                          </div>
                          <div class="tag">
                            <a title="MMORPG">{{tem.cateId?cateObj[tem.cateId]: '暂无分类'}}</a>
                            <a title="MMORPG">{{tem.subjectId?subObj[tem.subjectId]: '暂无题材'}}</a>
                          </div>
                        </div>
                      </a>
                    </div>-->
                  </el-col>
                </el-row>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8">
                <template>
                  <div class="n-m-title">
                    <span class="sp2">资讯</span>
                  </div>
                  <div style="height:10px;"></div>
                  <!-- <div class="b-text-box">
                  <template>
                    <a
                      class="b-tb-tem"
                      target="_blank"
                      :href="'/article?id='+item.id"
                      v-for="(item,index) in textArr"
                      :key="index"
                    >{{item.title}}</a>
                  </template>
                  <a class="b-tb-more" target="_blank" href="/list">更多游戏</a>
                  </div>-->

                  <div class="n-m-zx">
                    <div style="height:60px;"></div>
                    <a
                      class="m-z-tem"
                      target="_blank"
                      :href="'/article?id='+item.id"
                      v-for="(item,index) in textArr"
                      :key="index"
                    >{{item.title}}</a>
                  </div>
                </template>
                <div style="height:20px;"></div>
                <template>
                  <div class="n-m-title">
                    <span class="sp2">直播</span>
                  </div>
                  <div style="height:30px;"></div>
                  <div style="width: 100%; height: 280px;  border-radius: 5px;overflow:hidden;">
                    <iframe
                      style="width: 100%;height: 280px;"
                      src="https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=22914881&quality=0"
                      frameborder="no"
                      framespacing="0"
                      scrolling="no"
                      allow="autoplay; encrypted-media"
                      allowfullscreen="true"
                    ></iframe>
                  </div>
                  <div style="height:30px;"></div>
                  <div style="width: 100%; height: 280px;  border-radius: 5px;overflow:hidden;">
                    <iframe
                      style="width: 100%;height: 280px;"
                      src="https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=32430670&quality=0"
                      frameborder="no"
                      framespacing="0"
                      scrolling="no"
                      allow="autoplay; encrypted-media"
                      allowfullscreen="true"
                    ></iframe>
                  </div>
                  <!-- <iframe style="width: 700px;height: 400px;" src="https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=32430670&quality=0" frameborder="no"    framespacing="0" scrolling="no" allow="autoplay; encrypted-media" allowfullscreen="true"></iframe> -->
                </template>
              </el-col>
            </el-row>
          </div>
          <div style="height:20px;"></div>
          <div class="i-glue" id="glue">
            <div class="n-m-title">
              <span>攻略专区</span>
              <!-- <a target="_blank" href="/list">更多游戏</a> -->
            </div>
            <div style="height:30px;"></div>
            <el-row class="i-g-gl" :gutter="24">
              <el-col :md="6">
                <div class="gl-let">
                  <a
                    :href="'/guide?id='+item.id"
                    target="_blank"
                    class="tem"
                    v-for="(item,index) in glImgArr.slice(0, 5)"
                    :key="index"
                  >
                    <span></span>
                    <div class="ls" :style="`background-image: url(${item.coverImg})`"></div>
                    <div class="rg">{{item.title}}</div>
                  </a>
                </div>
              </el-col>
              <el-col :md="18">
                <div>
                  <el-carousel
                    :height="screenType=='small'?imgHeight+'px':'554px'"
                    :interval="5000"
                  >
                    <el-carousel-item v-for="(item,index) in glTextArr" :key="index">
                      <a
                        target="_blank"
                        class="banner-tem"
                        :href="'/guide?id='+item.id"
                        :style="`background-image: url(${item.coverImg})`"
                      ></a>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="height:20px;"></div>
          <div class="i-glue" id="video">
            <div class="n-m-title">
              <span>视频专区</span>
              <!-- <a target="_blank" href="/list">更多游戏</a> -->
            </div>
            <div style="height:30px;"></div>
            <el-row class="i-g-gl" :gutter="24">
              <el-col
                class="i-v-tem i-v-tem2"
                :xs="12"
                :sm="8"
                :md="8"
                v-for="(item,index) in videoArr"
                :key="index"
              >
                <a
                  :href="videoArr[index].link"
                  target="_blank"
                  :style="`background-image: url(${videoArr[index].coverImg})`"
                >
                  <span class="dec">
                    <i class="ico ico-pc"></i>
                  </span>
                  <i class="el-icon-video-play i-v-play"></i>
                </a>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="i-glue" id="glue" style="display:none;">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="16">
              <div class="b-title" style="background:#F09BA0;">
                新游速递
                <a class="b-tb-more" target="_blank" href="/list">更多游戏</a>
              </div>
              <el-row class="game-main">
                <el-col :xs="24" :sm="12" class="templete" v-for="tem in gameList" :key="tem.id">
                  <div class="con">
                    <a :href="'/more?id='+tem.id" target="_blank">
                      <div class="c1">
                        <span>
                          <img
                            :src="tem.coverImg.indexOf('http')>-1?tem.coverImg:'/api'+tem.coverImg"
                          />
                        </span>
                      </div>
                      <div class="c2">
                        <div class="tit">
                          <a :title="tem.name">{{tem.name}}</a>
                        </div>

                        <div class="info">
                          <span class="ex" :title="tem.schedule">测试情况：{{tem.schedule}}</span>
                          <span>运营商：{{tem.provider || '暂无'}}</span>
                        </div>
                        <div class="tag">
                          <a title="MMORPG">{{tem.cateId?cateObj[tem.cateId]: '暂无分类'}}</a>
                          <a title="MMORPG">{{tem.subjectId?subObj[tem.subjectId]: '暂无题材'}}</a>
                        </div>
                      </div>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="8">
              <div class="b-title" style="background:#76C5F0;">文章资讯</div>
              <div class="b-text-box">
                <template>
                  <a
                    class="b-tb-tem"
                    target="_blank"
                    :href="'/article?id='+item.id"
                    v-for="(item,index) in textArr"
                    :key="index"
                  >{{item.title}}</a>
                </template>
                <a class="b-tb-more" target="_blank" href="/list">更多游戏</a>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="i-glue" id="video" style="display:none;">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12">
              <div class="b-title" style="background:#F09BA0;">攻略专区</div>
              <div style="height:10px;"></div>
              <el-row>
                <el-col :xs="24" :sm="12" :md="12">
                  <el-carousel
                    :height="screenType=='small'?imgHeight+'px':'290px'"
                    arrow="always"
                    :interval="5000"
                  >
                    <el-carousel-item v-for="(item,index) in glImgArr" :key="index">
                      <a
                        target="_blank"
                        class="banner-tem"
                        :href="'/guide?id='+item.id"
                        :style="`background-image: url(${item.coverImg})`"
                      ></a>
                    </el-carousel-item>
                  </el-carousel>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                  <div style class="gl-text">
                    <template>
                      <a
                        class="b-tb-tem"
                        target="_blank"
                        :href="'/guide?id='+item.id"
                        v-for="(item,index) in glTextArr"
                        :key="index"
                      >{{item.title}}</a>
                    </template>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12">
              <div class="b-title" style="background:#76C5F0;">视频专区</div>
              <div style="height:10px;"></div>
              <el-row :gutter="10">
                <el-col
                  class="i-v-tem"
                  :xs="12"
                  :sm="8"
                  :md="8"
                  v-for="(item,index) in videoArr"
                  :key="index"
                >
                  <a
                    :href="videoArr[index].link"
                    target="_blank"
                    :style="`background-image: url(${videoArr[index].coverImg})`"
                  >
                    <span class="dec">
                      <i class="ico ico-pc"></i>
                    </span>
                    <i class="el-icon-video-play i-v-play"></i>
                  </a>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" width="1200px" top="20px">
        <iframe height="750px" :src="iframeUrl" width="100%" frameborder="0"></iframe>
      </el-dialog>
      <div style="height:60px;"></div>
      <Footer></Footer>
    </div>
  </el-scrollbar>
</template>

<script>
import { getSubjectList, getcateList, getHomeIndex } from '@/api/gameList'
import Header from '@/views/header.vue'
import Footer from '@/views/footer.vue'
export default {
  name: 'Dashboard',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      banner: [],
      gameList: [],
      subObj: {},
      cateObj: {},
      videoArr: [],
      textArr: [],
      glTextArr: [],
      glImgArr: [],
      eventArr: [],
      dialogVisible: false,
      iframeUrl: '',
      screenType: 'big',
      imgHeight: 0
    }
  },
  methods: {
    headerSearch () {
      getHomeIndex().then((data) => {
        this.banner = data.banner
        this.textArr = data.articles
        this.glImgArr = data.guides.left
        this.glTextArr = data.guides.right
        this.gameList = data.games
        this.videoArr = data.videos
        this.eventArr = data.events
        // console.log(86868, data)
      })
      getSubjectList().then((data) => {
        const myobj1 = {}
        data.forEach(tem => {
          myobj1[tem.id] = tem.title
        })
        this.subObj = Object.assign({}, myobj1)
      })
      getcateList().then((data) => {
        const myobj2 = {}
        data.forEach(tem => {
          myobj2[tem.id] = tem.title
        })
        this.cateObj = Object.assign({}, myobj2)
      })
    },
    handleClick (obj) {
      // console.log(111, obj.url)
      if (obj.url.indexOf('dhgm.xyz') > -1) {
        window.open(obj.url, '_blank')
      } else {
        // 如果标记为内嵌
        if (obj.isEmbed) {
          // 用专门处理iframe形式的页面打开,并把链接传过去打开处理
          this.dialogVisible = true
          this.iframeUrl = obj.url
        } else {
          window.open(obj.url, '_blank')
        }
      }
    },
    handleClick2 (obj) {
      var url = '/event?id=' + obj.id
      console.log(999, url)
      // window.open(obj.url, '_blank')
    },
    browserRedirect () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  created () {
    if (this.browserRedirect()) {
      // console.log('手机端打开')
      window.location = 'https://m.dhgm.xyz'
    }
    this.headerSearch()
    if (document.body.clientWidth < 768) {
      // console.log(1111, document.body.clientWidth)
      this.screenType = 'small'
      this.imgHeight = (document.body.clientWidth - 20) * 0.6
      // console.log(222, this.imgHeight)
    }
    // console.log(11134, this.browserRedirect())

    // https://live.bilibili.com/22914881?broadcast_type=0&is_room_feed=1&plat_id=265&share_from=live&share_medium=iphone&share_plat=ios&share_session_id=97462340-CB79-4813-96C3-934C040649E8&share_source=COPY&share_tag=s_i&timestamp=1721197760&unique_k=10ekRmM
    // <iframe style="width: 700px;height: 400px;" src="https://www.bilibili.com/blackboard/live/live-activity-player.html?cid=22914881&quality=0" frameborder="no"    framespacing="0" scrolling="no" allow="autoplay; encrypted-media" allowfullscreen="true"></iframe>
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.index-box {
  background: url("/static/img/bg_01.jpg") center 600px no-repeat;
  background-size: 100% 100%;
  overflow-x: hidden;
  .i-mtop {
    height: 100px;
    margin-top: 20px;
    background: #333;
    .i-m-content {
      width: 1100px;
      height: 100px;
      margin: 0 auto;
      position: relative;
    }
    .i-logo {
      position: absolute;
      height: 110px;
      width: auto;
      left: -15px;
      top: -11px;
    }
  }
  .i-menu {
    background: #4277d0;
    width: 1100px;
    margin: 20px auto 0px;
    height: 46px;
    .i-m-tem {
      float: left;
      width: 25%;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: white;
      i {
        font-size: 18px;
        vertical-align: text-top;
        margin-right: 5px;
      }
    }
  }
  .i-banner {
    // width: 1280px;
    // margin: 0 auto;
    .el-carousel__indicator--horizontal .el-carousel__button {
      width: 12px;
      height: 12px;
      // opacity: 0.5;
      background: white;
      border: 2px solid #ffffff;
      border-radius: 2px;
    }
    .is-active .el-carousel__button {
      width: 26px;
      height: 12px;
      background-image: linear-gradient(90deg, #ff8789 0%, #9ed8f5 100%);
      border: 2px solid #ffffff;
      border-radius: 2px;
    }
  }
  .banner-tem {
    display: block;
    width: 100%;
    height: 880px;
    background-size: cover;
    background-position: center center;
    position: relative;
    cursor: pointer;
    .b-cover,
    .b-text {
      position: absolute;
      width: 100%;
      height: 80px;
      left: 0;
      bottom: 0;
    }
    .b-cover {
      background: rgba(0, 0, 0, 0.7);
    }
    .b-text {
      padding: 0 20px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 80px;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 22px;
    }
  }
  .i-glue {
    margin: 0px auto 0;
  }
  .game-main {
    .templete {
      border-bottom: 1px solid #eee;
      padding: 15px 0 20px;
      position: relative;
      .con {
        // padding: 0 110px 0 0;
        position: relative;
        .c1 {
          float: left;
          margin-right: 20px;
          padding-top: 5px;
          span {
            display: block;
            width: 160px;
            height: 90px;
            background: #000;
            overflow: hidden;
            img {
              width: 160px;
              height: auto;
            }
          }
        }
        .c2 {
          overflow: hidden;
          font-size: 14px;

          .tit {
            margin-bottom: 3px;
            font-size: 16px;
            font-weight: 700;
            padding-top: 4px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .info {
            color: #999;
            overflow: hidden;
            margin-bottom: 5px;
            span {
              line-height: 24px;
              display: block;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              max-width: 95%;
            }
          }
          .tag {
            overflow: hidden;
            a {
              float: left;
              line-height: 20px;
              padding: 0 7px;
              background: #a4b7d7;
              color: #fff;
              margin: 0 4px 4px 0;
            }
          }
        }
        .c3 {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -51px;
          .channel {
            width: 100px;
            text-align: center;
            position: relative;
            a {
              display: block;
              margin: 10px 0;
              line-height: 34px;
              font-size: 14px;
              border: 1px solid #e0e0e0;
              border-radius: 18px;
              background: #fff;
              i {
                background: url("/static/img/sprite.png") no-repeat;
                margin: 0 7px 3px 0;
                display: inline-block;
                width: 12px;
                height: 12px;
                vertical-align: middle;
              }
              .ico-video-s {
                background-position: -35px -135px;
              }
              .ico-pic-s {
                background-position: -20px -135px;
              }
            }
          }
        }
      }
    }
    .templete:before {
      content: "";
      display: block;
      width: 0;
      border-top: 1px solid #609bff;
      position: absolute;
      left: 0;
      bottom: -1px;
      -webkit-transition: width 0.4s;
      transition: width 0.4s;
    }
  }
  .i-glue {
    padding-top: 20px;
  }
  .i-g-title {
    line-height: 50px;
    font-size: 18px;
    font-weight: 700;
    z-index: 5;
    color: #222;
    margin-bottom: 10px;
    border-top: 1px solid #f1f1f1;
  }
  .i-v-tem {
    height: 140px;
    margin-bottom: 10px;
    a {
      display: block;
      height: 140px;
      border-radius: 10px;
      background-size: cover;
      background-position: center center;
      position: relative;
      span {
        // background: -webkit-gradient(
        //   linear,
        //   left top,
        //   left bottom,
        //   color-stop(1%, rgba(0, 0, 0, 0)),
        //   color-stop(30%, rgba(0, 0, 0, 0.3)),
        //   color-stop(50%, rgba(0, 0, 0, 0.6)),
        //   color-stop(70%, rgba(0, 0, 0, 0.8)),
        //   to(#000)
        // );
        // background: -o-linear-gradient(
        //   top,
        //   rgba(0, 0, 0, 0) 1%,
        //   rgba(0, 0, 0, 0.3) 30%,
        //   rgba(0, 0, 0, 0.6) 50%,
        //   rgba(0, 0, 0, 0.8) 70%,
        //   #000 100%
        // );
        // background: linear-gradient(
        //   180deg,
        //   rgba(0, 0, 0, 0) 1%,
        //   rgba(0, 0, 0, 0.3) 30%,
        //   rgba(0, 0, 0, 0.6) 50%,
        //   rgba(0, 0, 0, 0.8) 70%,
        //   #000
        // );
        // filter: progid:DXImageTransform.Microsoft.gradient(enabled="true",startColorstr="#00000000",endColorstr="#ff000000");
        // cursor: pointer;
        // position: absolute;
        // width: 100%;
        // left: 0;
        // bottom: 0;
        // color: #fff;
        // height: 21px;
      }
      // .i-v-play {
      //   position: absolute;
      //   left: 10px;
      //   bottom: 10px;
      //   font-size: 40px;
      //   color: white;
      // }
    }
  }
  .i-v-tem2 {
    height: 278px;
    a {
      height: 278px;
      span {
        position: absolute;
        cursor: pointer;
        width: 110px;
        height: 100px;
        left: 50%;
        top: 50%;
        margin-left: -55px;
        margin-top: -50px;
        background: url("/static/img/bf.png") no-repeat;
      }
    }
  }
  .i-text-box {
    margin-left: 170px;
    padding: 20px 10px;
    overflow: hidden;
    a {
      float: left;
      line-height: 30px;
      margin-right: 30px;
      white-space: nowrap;
      color: #999;
    }
  }

  .banner-box {
    // width: 1280px;
    // margin-left: auto;
    // margin-right: auto;
  }
  .b-title {
    height: 40px;
    position: relative;
    background-image: linear-gradient(#5b5b5b, #222222);
    color: white;
    text-indent: 1em;
    font-size: 16px;
    line-height: 40px;
    border-radius: 5px 5px 0 0;
    text-shadow: black 0.1em 0.1em 0.2em;
  }
}

.i-banner .el-carousel__arrow {
  width: 46px;
  height: 54px;
  &.el-carousel__arrow--left {
    background: url("/static/img/left.png") center center no-repeat;
    left: 120px;
    i {
      &::before {
        content: "";
      }
    }
  }
  &.el-carousel__arrow--right {
    background: url("/static/img/right.png") center center no-repeat;
    right: 120px;
    i {
      &::before {
        content: "";
      }
    }
  }
  i {
    font-size: 18px;
  }
}
.i-banner .el-carousel__indicators--horizontal {
  bottom: 80px;
}
.b-text-box {
  box-sizing: border-box;
  height: 415px;
  border: 1px solid #eee;
  background: #f5f5f5;
  padding: 10px;
  position: relative;
}
.b-tb-tem {
  display: block;
  height: 31px;
  line-height: 31px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 14px;
  text-indent: 20px;
  color: #333;
  background: url("/static/img/lx.png") 0 center no-repeat;
  &:hover {
    color: #ff5c00;
  }
}
.b-tb-more {
  position: absolute;
  right: 16px;
  bottom: -5px;
  padding: 5px 10px;
  // background-image: linear-gradient(#5b5b5b, #222222);
  color: white;
  border-radius: 2px;
  font-size: 12px;
  &:hover {
    color: white;
  }
}
.gl-text {
  height: 290px;
  padding: 10px;
  box-sizing: border-box;
  background: #f5f5f5;
}
@media (max-width: 768px) {
  .b-text-box {
    height: auto;
  }
  .gl-text {
    height: auto;
    margin-bottom: 10px;
  }
  .index-box .banner-tem {
    height: 0;
    padding-bottom: 60%;
  }
  .i-banner .el-carousel__arrow {
    display: none;
  }
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.new-main {
  width: 1518px;
  margin: 0 auto;
  .act-tle {
    width: 452px;
    height: 90px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    line-height: 90px;
    background: url("/static/img/title_bg.png") center center no-repeat;
    font-size: 38px;
    font-weight: bold;
    margin-bottom: 24px;
  }
  .activity {
    .el-carousel__item--card {
      // width: 55%;
      background: url("/static/img/zxhd_bg1.png") center center no-repeat;
    }
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 200px;
      margin: 0;
      text-align: center;
    }
    .el-carousel__indicators {
      display: none;
    }
    .el-carousel__mask {
      background: none;
    }
    .el-carousel__arrow {
      width: 46px;
      height: 54px;
      &.el-carousel__arrow--left {
        background: url("/static/img/left.png") center center no-repeat;
        left: 380px;
        i {
          &::before {
            content: "";
          }
        }
      }
      &.el-carousel__arrow--right {
        background: url("/static/img/right.png") center center no-repeat;
        right: 380px;
        i {
          &::before {
            content: "";
          }
        }
      }
      i {
        font-size: 18px;
      }
    }
    .el-carousel__item:nth-child(2n) {
    }

    .el-carousel__item:nth-child(2n + 1) {
    }
  }
  .n-m-title {
    height: 90px;
    position: relative;
    text-align: center;
    span {
      display: inline-block;
      width: 452px;
      height: 90px;
      line-height: 90px;
      background: url("/static/img/title_bg.png") center center no-repeat;
      font-size: 38px;
      font-weight: bold;
    }
    .sp2 {
      width: 372px;
      height: 92px;
      font-size: 36px;
      background: url("/static/img/title_bg2.png") center center no-repeat;
    }

    a {
      position: absolute;
      width: 141px;
      height: 46px;
      background: url("/static/img/bg_more1.png") center center no-repeat;
      right: 0;
      top: 20px;
      text-align: left;
      line-height: 48px;
      color: #a36b29;
      font-size: 14px;
      text-indent: 36px;
    }
  }
  .n-m-g-tem {
    height: 360px;
    a {
      display: block;
      height: 360px;
      background-size: cover;
      background-position: center center;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .g-t-cover {
        position: absolute;
        width: 100%;
        height: 100px;
        opacity: 0.8;
        background: #363d4e;
        border-radius: 0 0 8px 8px;
        left: 0;
        bottom: 0;
      }
      .g-t-info {
        position: absolute;
        width: 100%;
        height: 100px;
        bottom: 0;
        left: 0;
        text-align: center;
        p {
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: white;
          text-shadow: 0 1px 1px #00000080;
          margin-bottom: 5px;
        }
        span {
          display: inline-block;
          width: 88px;
          height: 36px;
          background: url("/static/img/btn_1bg.png") center center no-repeat;
          line-height: 36px;
          font-size: 14px;
          overflow: hidden;
          margin-right: 8px;
        }
      }
    }
  }
  .n-m-zx {
    height: 426px;
    background: url("/static/img/zx_bg.png") center center no-repeat;
    background-size: 100%;
    .m-z-tem {
      display: block;
      line-height: 38px;
      text-indent: 48px;
      background: url("/static/img/xbt.png") 22px center no-repeat;
    }
  }
  .i-g-gl {
    .gl-let {
      .tem {
        display: block;
        height: 104px;
        background-color: rgba(54, 61, 78, 0.6);
        border-radius: 8px;
        box-sizing: border-box;
        padding: 2px;
        margin-bottom: 8px;
        overflow: hidden;
        position: relative;
        span {
          width: 0;
          transition: width 1s;
          -webkit-transition: width 1s;
        }
        &:hover {
          // background: url("/static/img/bg_gl.png") right center no-repeat;
          // background-color: rgba(54, 61, 78, 0.6);
          // transition: width 2s;
          // -webkit-transition: width 2s;
          span {
            position: absolute;
            z-index: 0;
            right: 0;
            top: 0;
            background: url("/static/img/bg_gl.png") right center no-repeat;
            background-color: rgba(54, 61, 78, 0.6);
            width: 196px;
            height: 104px;
          }
          .rg {
            color: #1a1a1a;
          }
        }
        .ls {
          float: left;
          width: 160px;
          height: 100px;
          background-size: 100%;
          border-radius: 8px;
        }
        .rg {
          position: relative;
          z-index: 1;
          margin-left: 160px;
          padding: 10px 10px;
          line-height: 30px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
}

.event-tem {
  display: block;
  width: 600px;
  height: 464px;
  background-size: cover;
  background-position: center center;
  position: relative;
  cursor: pointer;
  margin-left: 80px;
  margin-top: 16px;
}
</style>
